import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Alert, Box, CircularProgress, Container, Stack, Typography } from '@mui/material';
import VirtualAbacus from '../components/Abacus/VirtualAbacus';
import abacusService, { AbacusTopicDetailsDTO } from '../services/abacusService';

const TutorAbacusTopicPage: React.FC = () => {
  const { sessionId, topicId } = useParams<{ sessionId: string; topicId: string }>();
  const [topic, setTopic] = useState<AbacusTopicDetailsDTO | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const load = async () => {
      if (!sessionId || !topicId) return;
      try {
        setTopic(await abacusService.getTutorTopic(Number(sessionId), Number(topicId)));
      } catch {
        setError('This topic could not be opened.');
      }
    };
    void load();
  }, [sessionId, topicId]);

  if (error) {
    return (
      <Container sx={{ py: 4 }}>
        <Alert severity="error">{error}</Alert>
      </Container>
    );
  }
  if (!topic) {
    return (
      <Box minHeight="40vh" display="flex" alignItems="center" justifyContent="center">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Typography variant="h4" fontWeight={700} mb={1}>
        {topic.title}
      </Typography>
      <Typography variant="body2" color="text.secondary" mb={2}>
        Same lesson the learner sees. No replacement video is uploaded here.
      </Typography>
      <Stack spacing={1} mb={3}>
        {(topic.resources ?? []).map((resource) => (
          <Typography key={resource.id} variant="body1" data-testid={`theory-resource-${resource.id}`}>
            {`${resource.title ?? resource.type} · resource ${resource.id}`}
          </Typography>
        ))}
      </Stack>
      {topic.interactive?.type === 'VIRTUAL_ABACUS' && (
        <VirtualAbacus columns={Math.max(2, topic.interactive.columns ?? 2)} />
      )}
    </Container>
  );
};

export default TutorAbacusTopicPage;
